// extracted by mini-css-extract-plugin
export var active = "_9g-d";
export var blink = "_9g-e";
export var container = "_9g-5";
export var controls = "_9g-0";
export var controlsRight = "_9g-1";
export var fakeCursor = "_9g-c";
export var hidden = "_9g-b";
export var quillContainerSmall = "_9g-7";
export var quillEditor = "_9g-6";
export var quillEditorSmall = "_9g-8";
export var quillFormatButtons = "_9g-a";
export var quillToolbar = "_9g-9";
export var removePadding = "_9g-2";
export var state = "_9g-3";
export var stateTitle = "_9g-4";